// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../factories/translate-dialog";
import "./../bindings/bao-searcher";
import BaseViewModel from "./../factories/base-view-model2";
import BaoDialog from "./../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../services/bao-service";

import TranslateDialogViewModel from "./../factories/translate-dialog";
class ShiftbookTab extends BaseViewModel {
    constructor(tabPage: TabPage) {
        super(tabPage);

        this.ShiftbookTabTypeObject.subscribe((value) => {
            if (this.AfterInit()) {
                this.SummaryReportId(undefined);
                this.SummaryReportName(undefined);
                this.ChecklistCategoryId(undefined);
                this.ChecklistCategoryName(undefined);
                this.FolderStructureChecklistId(undefined);
                this.FolderStructureChecklistName(undefined);
            }
            this.IsChecklistTab(false);
            if (value?.Key.toLocaleUpperCase() === 'SAMMELBERICHT') {
                this.SummaryReportVisible(true);
                this.IsBypassBook(false);
                this.IsCheckwareTab(false);
            }
            else if (value?.Key.toLocaleUpperCase() === 'BRÜCKENBUCH') {
                this.IsBypassBook(true);
                this.SummaryReportVisible(false);
                this.IsCheckwareTab(false);
            }
            else if (value?.Key.toLocaleUpperCase() === 'CHECKWARE') {
                this.IsBypassBook(false);
                this.SummaryReportVisible(false);
                this.IsCheckwareTab(true);
            }
            else if (value?.Key.toLocaleUpperCase() === 'CHECKLISTE') {
                this.IsBypassBook(false);
                this.SummaryReportVisible(false);
                this.IsCheckwareTab(false);
                this.IsChecklistTab(true);
            }
            else {
                this.SummaryReportVisible(false);
                this.IsBypassBook(false);
                this.IsCheckwareTab(false);
            }
            if (this.AfterInit()) {
                this.loadTabs();
            }
        });    
    }
    Name = ko.pureComputed<string>({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.Name1();
                case 2:
                    return this.Name2();
                case 3:
                    return this.Name3();
                case 4:
                    return this.Name4();
                case 5:
                    return this.Name5();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.Name1(value);
                    break;
                case 2:
                    this.Name2(value);
                    break;
                case 3:
                    this.Name3(value);
                    break;
                case 4:
                    this.Name4(value);
                    break;
                case 5:
                    this.Name5(value);
                    break;
            }
        }
    });
    ShiftbookTabUniversalFieldTab: TabPage;
    ShiftbookTabMandatorTab: TabPage;
    ShiftbookTabFieldTab: Factories.TabPage;
    test: KnockoutObservable<string> = ko.observable();
    Name1: KnockoutObservable<string> = ko.observable();
    Name2: KnockoutObservable<string> = ko.observable();
    Name3: KnockoutObservable<string> = ko.observable();
    Name4: KnockoutObservable<string> = ko.observable();
    Name5: KnockoutObservable<string> = ko.observable();
    Description: KnockoutObservable<string> = ko.observable();
    Preload: KnockoutObservable<boolean> = ko.observable();
    AssemblyName: KnockoutObservable<string> = ko.observable();
    ReflectionType: KnockoutObservable<string> = ko.observable();
    ShiftbookTabTypeName: KnockoutObservable<string> = ko.observable();
    ShiftbookTabTypeObject: KnockoutObservable<any> = ko.observable({});
    ShiftbookTabTypeId: KnockoutObservable<string> = ko.observable();
    SummaryReportId: KnockoutObservable<string> = ko.observable();
    SummaryReportName: KnockoutObservable<string> = ko.observable();
    SummaryReportVisible: KnockoutObservable<boolean> = ko.observable();
    ChecklistCategoryId: KnockoutObservable<string> = ko.observable();
    ChecklistCategoryName: KnockoutObservable<string> = ko.observable();
    FolderStructureChecklistId = ko.observable<string>();
    FolderStructureChecklistName = ko.observable<string>();
    IsBypassBook: KnockoutObservable<boolean> = ko.observable();
    IsCheckwareTab: KnockoutObservable<boolean> = ko.observable();
    IsChecklistTab: KnockoutObservable<boolean> = ko.observable();
    AfterInit: KnockoutObservable<boolean> = ko.observable(false);
    ManualCompletion: KnockoutObservable<boolean> = ko.observable(false);
    ShiftbookTabTypeSearcher: Bindings.baoSearcher = {
        SearchType: "ShiftbookTabType",
        ObjectId: this.ShiftbookTabTypeId,
        ObjectValue: "Key",
        AutoComplete: true,
        AutoSearch: true,
        SelectedItem: this.ShiftbookTabTypeObject
    };
    SummaryReportFilterSearcher: Bindings.baoSearcher = {
        SearchType: "SummaryReportFilter",
        ObjectId: this.SummaryReportId,
        ObjectValue: "Name",
        AutoComplete: true,
        AutoSearch: true
    };

    ChecklistCategorySearcher: Bindings.baoSearcher = {
        SearchType: "ChecklistCategory",
        ObjectId: this.ChecklistCategoryId,
        ObjectValue: "ChecklistCategoryName",
        AutoComplete: true,
        AutoSearch: true
    };

    FolderStructureChecklistSearcher : Bindings.baoSearcher = {
        ObjectId: this.FolderStructureChecklistId,
        SearchType: 'Checkware-FolderStructureChecklist',
        ObjectValue: 'ListName',
        AutoComplete: true,
        AutoSearch: true
    };

    InitUrl() {
        return "ShiftbookTab/Init";
    }
    Translate() {
        var translateDialog = new TranslateDialogViewModel(this.Name1, this.Name2, this.Name3, this.Name4, this.Name5);
        translateDialog.Open();
    }
    ;
    CompleteCheck() {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(this.Name())) {
            isComplete = false;
        }
        if (this.Preload() === undefined || this.Preload() === null) {
            isComplete = false;
        }
        if (this.IsBypassBook() && Bao.Utils.String.IsNullOrEmpty(this.ChecklistCategoryId())) {
            isComplete = false;
        }
        if (this.IsCheckwareTab() && Bao.Utils.String.IsNullOrEmpty(this.FolderStructureChecklistId())) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrEmpty(this.ShiftbookTabTypeId())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }

    init() {
        return super.init().then(() => {
            return this.InitTabController();
        }).then(() => {           
            if (!Bao.Utils.String.IsNullOrEmpty(ko.unwrap(this.ShiftbookTabTypeName))) {
                this.ShiftbookTabTypeObject({ Key: this.ShiftbookTabTypeName() });
            }
             this.AfterInit(true);
            this.loadTabs();
        });
    }

    private loadTabs = () => {
        this.TabController.DestroyAll();
        if (this.IsBypassBook() || this.IsChecklistTab()) {
            this.ShiftbookTabFieldTab = new TabPage();
            this.ShiftbookTabFieldTab.IsClosable(false);
            this.ShiftbookTabFieldTab.Url("ShiftbookTabField");
            this.ShiftbookTabFieldTab.AutoSelect = true;
            this.TabController.AddTab(this.ShiftbookTabFieldTab);
        }
        else {
            this.ShiftbookTabUniversalFieldTab = new TabPage();
            this.ShiftbookTabUniversalFieldTab.IsClosable(false);
            this.ShiftbookTabUniversalFieldTab.Url("ShiftbookTabUniversalField");
            this.ShiftbookTabUniversalFieldTab.AutoSelect = true;
            this.TabController.AddTab(this.ShiftbookTabUniversalFieldTab);
        }
        this.ShiftbookTabMandatorTab = new TabPage();
        this.ShiftbookTabMandatorTab.IsClosable(false);
        this.ShiftbookTabMandatorTab.Url("ShiftbookTabMandator");
        this.ShiftbookTabMandatorTab.AutoSelect = false;
        this.TabController.AddTab(this.ShiftbookTabMandatorTab);

    }
}
export default ShiftbookTab;